<div
  mat-dialog-actions
  class="actions-double"
  [class]="wrapperClass()"
  [class.single-btn]="!showConfirm()"
>
  <button class="btn btn-cancel" type="button" mat-dialog-close>
    {{ cancelLabel() }}
  </button>
  @if (showConfirm()) {
    <button
      class="btn"
      [class.btn-green]="confirmVariant() === 'primary'"
      [class.btn-delete]="confirmVariant() === 'danger'"
      type="submit"
      [mat-dialog-close]="dialogResult()"
    >
      {{ confirmLabel() }}
    </button>
  }
</div>
